import { render, staticRenderFns } from "./ar_check.vue?vue&type=template&id=b0563dc0&scoped=true&"
import script from "./ar_check.vue?vue&type=script&lang=js&"
export * from "./ar_check.vue?vue&type=script&lang=js&"
import style0 from "./ar_check.vue?vue&type=style&index=0&id=b0563dc0&scoped=true&lang=less&"
import style1 from "./ar_check.vue?vue&type=style&index=1&id=b0563dc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0563dc0",
  null
  
)

export default component.exports